import PainelAPI from '../../api/painel';

const state = {
  appointments: [],
  meta: { date: null, lastSyncAt: null },
  uiFlags: { isFetching: false, isUpdating: {} },
};

const getters = {
  getAppointments: $state => $state.appointments,
  getAppointmentsMeta: $state => $state.meta,
  getAppointmentsUiFlags: $state => $state.uiFlags,
};

const mutations = {
  SET_APPOINTMENTS($state, appointments) {
    $state.appointments = appointments;
  },
  SET_META($state, patch) {
    $state.meta = { ...$state.meta, ...patch };
  },
  SET_UI($state, { flag, value }) {
    $state.uiFlags[flag] = value;
  },
  SET_UPDATING($state, { id, value }) {
    $state.uiFlags.isUpdating = { ...$state.uiFlags.isUpdating, [id]: value };
  },
  PATCH_APPOINTMENT($state, payload) {
    $state.appointments = $state.appointments.map(a =>
      a.id === payload.id ? { ...a, ...payload } : a
    );
  },
  UPSERT_APPOINTMENT($state, appt) {
    const idx = $state.appointments.findIndex(a => a.id === appt.id);
    if (idx >= 0) $state.appointments.splice(idx, 1, appt);
  },
  UPDATE_APPOINTMENT_FIELD($state, { id, field, value }) {
    const a = $state.appointments.find(x => x.id === id);
    if (a) a[field] = value;
  },
};

const actions = {
  fetchByDate: async ({ commit }, { date, includeCancelled = false } = {}) => {
    commit('SET_UI', { flag: 'isFetching', value: true });
    try {
      const { data } = await PainelAPI.fetchAppointments({
        date,
        include_cancelled: includeCancelled,
      });
      commit('SET_APPOINTMENTS', data.appointments || []);
      commit('SET_META', { date });
    } finally {
      commit('SET_UI', { flag: 'isFetching', value: false });
    }
  },

  fetch: async ({ commit }, params = {}) => {
    commit('SET_UI', { flag: 'isFetching', value: true });
    try {
      const { data } = await PainelAPI.fetchAppointments(params);
      commit('SET_APPOINTMENTS', data.appointments || []);
    } finally {
      commit('SET_UI', { flag: 'isFetching', value: false });
    }
  },

  create: async ({ dispatch, state: _state }, payload) => {
    const isoStart = new Date(payload.starts_at).toISOString();
    const { data } = await PainelAPI.createAppointment({
      ...payload,
      starts_at: isoStart,
    });
    if (_state.meta?.date) {
      dispatch('fetchByDate', { date: _state.meta.date });
    }
    return data.payload;
  },

  update: async ({ commit }, { id, payload }) => {
    const { data } = await PainelAPI.updateAppointment(id, payload);
    commit('UPSERT_APPOINTMENT', data.payload);
    return data.payload;
  },

  remove: async ({ commit }, { id, note = null }) => {
    const { data } = await PainelAPI.deleteAppointment(id, { note });
    commit('UPSERT_APPOINTMENT', data.payload);
    return data.payload;
  },

  restore: async ({ dispatch }, id) =>
    dispatch('update', { id, payload: { archived: false } }),

  retrySync: async ({ commit }, id) => {
    await PainelAPI.retrySync(id);
    commit('UPDATE_APPOINTMENT_FIELD', {
      id,
      field: 'google_sync_status',
      value: 'pending',
    });
  },
};

export default { namespaced: true, state, getters, mutations, actions };
